import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=abd8b218&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abd8b218')) {
      api.createRecord('abd8b218', component.options)
    } else {
      api.reload('abd8b218', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=abd8b218&", function () {
      api.rerender('abd8b218', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2G3tkQTu53nNm/JS/comp/FavElement.vue"
export default component.exports